/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ imported: NonNullable<unknown>, updated: NonNullable<unknown> }} Customer_Kiotviet_Last_SyncInputs */

const vi_customer_kiotviet_last_sync = /** @type {(inputs: Customer_Kiotviet_Last_SyncInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lần gần nhất: +${i?.imported} mới, ${i?.updated} cập nhật`)
};

/**

* @param {Customer_Kiotviet_Last_SyncInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_kiotviet_last_sync = /** @type {((inputs: Customer_Kiotviet_Last_SyncInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Kiotviet_Last_SyncInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_kiotviet_last_sync(inputs)
});